import { FTNavEvents } from "../types/ftnav";
import { FTNAV_EVENT } from "../types/ftnav/constants";

export class FTNavEvent {
  static close() {
    window.o_global.events<FTNavEvents>().emit(FTNAV_EVENT.CLOSE);
  }
}
